export class ContactForm {
  public name!: string;
  public email!: string;
  public message!: string;
}
